import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

const TXT = {
  fr: {
    tag: "[ MON COMPTE ]", title: "Pas encore de compte.", body: "Ton projet est enregistré sur cet appareil. Crée ton compte au moment de télécharger : tu le retrouves partout, avec tes vidéos et tes compteurs.",
    login: "Se connecter", register: "Créer un compte", projects: "Retour à mes projets",
    lang: "Langue",
  },
  en: {
    tag: "[ MY ACCOUNT ]", title: "No account yet.", body: "Your project is saved on this device. Create your account when you download: you will find it everywhere, with your videos and counters.",
    login: "Sign in", register: "Create an account", projects: "Back to my projects",
    lang: "Language",
  },
};

export default function AnonymousAccount() {
  const { lang, setLang } = useI18n();
  const t = TXT[lang] || TXT.fr;
  return (
    <main className="mx-auto w-full max-w-3xl px-5 sm:px-8 py-8 sm:py-12" data-testid="anonymous-account">
      <p className="font-osd text-xs tracking-[0.25em] text-primary mb-3">{t.tag}</p>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mb-5">{t.title}</h1>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-xl mb-8">{t.body}</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link to="/login" state={{ from: "/projects" }} data-testid="anon-login-link" className="inline-flex items-center justify-center rounded-full bg-primary text-white font-osd text-[11px] tracking-[0.08em] uppercase h-11 px-6">{t.login}</Link>
        <Link to="/register" state={{ from: "/projects" }} data-testid="anon-register-link" className="inline-flex items-center justify-center border border-border font-osd text-[11px] tracking-[0.08em] uppercase h-11 px-6 hover:border-foreground">{t.register}</Link>
        <Link to="/projects" data-testid="anon-projects-link" className="inline-flex items-center justify-center font-osd text-[11px] tracking-[0.08em] uppercase h-11 px-4 text-muted-foreground hover:text-foreground">{t.projects}</Link>
      </div>
      <div className="mt-10 pt-8 border-t border-border">
        <button onClick={() => setLang(lang === "fr" ? "en" : "fr")} data-testid="anon-lang-toggle" className="border border-border h-11 px-4 font-osd text-[11px] tracking-[0.08em] uppercase hover:border-foreground">
          {t.lang} : {lang === "fr" ? "Français" : "English"}
        </button>
      </div>
    </main>
  );
}
